import { useEffect, useState } from "react";

export default function useScreen() {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getW = () => (windowSize?.width && windowSize.width > 0)
        ? windowSize.width
        : Number.MAX_SAFE_INTEGER;

    return {
        size: windowSize,
        lessThan1200: getW() < 1200,
        lessThan992: getW() < 992,
        lessThan900: getW() < 900,
        isMobile: getW() < 800,
        lessThan768: getW() < 768,
        lessThan700: getW() < 700,
        lessThan600: getW() < 600,
        lessThan500: getW() < 500,
    };
}